import { useEffect, useRef, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { api, formatApiError, setToken } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

export default function AuthCallback() {
  const loc = useLocation();
  const nav = useNavigate();
  const { setUser } = useAuth();
  const [err, setErr] = useState("");
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = loc.hash || window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) { nav("/login"); return; }
    const session_id = decodeURIComponent(match[1]);
    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id });
        if (data.access_token) setToken(data.access_token);
        setUser(data);
        nav("/dashboard", { replace: true });
      } catch (e) {
        setErr(formatApiError(e.response?.data?.detail) || "OAuth failed");
        setTimeout(() => nav("/login"), 2500);
      }
    })();
  }, [loc, nav, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center" data-testid="auth-callback">
      <div className="text-center">
        <div className="font-mono text-xs text-[var(--span-text-2)] tracking-[0.2em] uppercase">
          {err ? "AUTH FAILED" : "EXCHANGING SESSION…"}
        </div>
        {err && <div className="text-[12px] text-[var(--span-danger)] mt-3">{err}</div>}
      </div>
    </div>
  );
}
